<template>
  <div class="dsa-portal">
    <header class="dsa-header">
      <nav>
        <div class="container">
          <div class="logo" @click="$router.push('/institution/dashboard')">DSA<span>Institutional Portal</span></div>
          <div class="nav-links institution">
            <router-link to="/institution/dashboard">Dashboard</router-link>
            <router-link to="/institution/catalog">Subject Catalog</router-link>
            <router-link to="/institution/registrations">Registrations</router-link>
            <router-link to="/institution/past-quarters">Past Quarters</router-link>
          </div>
          <div class="user">
            <div class="avatar">{{ initials }}</div>
            <span class="name">{{ accountName }}</span>
            <button type="button" class="signout" @click="signOut">Sign out</button>
          </div>
        </div>
      </nav>
    </header>
    <main ref="main" class="dsa-main">
      <div class="container dsa-main-inner">
        <dsa-loading v-if="routeLoading" text="Loading page…" />
        <router-view v-show="!routeLoading" @toast="showToast" />
      </div>
    </main>
    <footer class="dsa-footer">
      <div class="container">DSA Deep Scholastic Assessment · Institutional Portal</div>
    </footer>
    <div class="dsa-toast" :class="{ show: toastVisible }">{{ toastMessage }}</div>
    <div v-if="signOutConfirm" class="modal-overlay" @click.self="signOutConfirm = false">
      <div class="modal-card">
        <h3>Sign out?</h3>
        <p>Are you sure you want to sign out of the institutional portal?</p>
        <div class="actions">
          <button type="button" class="btn btn-outline" @click="signOutConfirm = false">Cancel</button>
          <button type="button" class="btn btn-primary" @click="confirmSignOut">Sign out</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAccountName, getInstitutionAccountId, logoutInstitution } from '@/utils/store'
import { getInitials } from '@/utils/dsaFormat'

export default {
  name: 'InstitutionLayout',
  data() {
    return {
      toastMessage: '',
      toastVisible: false,
      toastTimer: null,
      routeLoading: false,
      signOutConfirm: false,
    }
  },
  computed: {
    accountName() {
      return getAccountName() || 'Institution'
    },
    initials() {
      return getInitials(this.accountName)
    },
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        if (this.$refs.main) this.$refs.main.scrollTop = 0
      })
    },
  },
  created() {
    this._removeBefore = this.$router.beforeResolve((to, from, next) => {
      if (to.path.startsWith('/institution') && from.path.startsWith('/institution') && to.path !== from.path) {
        this.routeLoading = true
      }
      next()
    })
    this._removeAfter = this.$router.afterEach(() => {
      this.$nextTick(() => {
        this.routeLoading = false
      })
    })
  },
  beforeDestroy() {
    if (this._removeBefore) this._removeBefore()
    if (this._removeAfter) this._removeAfter()
  },
  methods: {
    signOut() {
      this.signOutConfirm = true
    },
    confirmSignOut() {
      this.signOutConfirm = false
      logoutInstitution()
      this.$router.push('/login')
    },
    showToast(msg) {
      this.toastMessage = msg
      this.toastVisible = true
      clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => {
        this.toastVisible = false
      }, 2200)
    },
  },
  mounted() {
    if (!getInstitutionAccountId()) {
      this.$router.replace('/login')
    }
  },
}
</script>

<style scoped>
.modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,.4);display:flex;align-items:center;justify-content:center;z-index:1000}
.modal-card{background:#fff;border-radius:14px;padding:24px;max-width:400px;width:90%;box-shadow:0 12px 40px rgba(15,23,42,.16)}
.modal-card h3{font-size:18px;font-weight:700;margin:0 0 8px}
.modal-card p{font-size:14px;color:var(--muted,#64748b);margin:0 0 20px;line-height:1.5}
.modal-card .actions{display:flex;justify-content:flex-end;gap:10px}
</style>
